import { useTranslation } from "react-i18next";

interface PromoCodeInputProps {
  value: string;
  onChange: (value: string) => void;
  onApply: () => void;
  loading: boolean;
}

export default function PromoCodeInput({
  value,
  onChange,
  onApply,
  loading,
}: PromoCodeInputProps) {
  const { t } = useTranslation(["pages", "common"]);
  return (
    <div className="mb-4">
      <label className="block text-xs text-gray-500 mb-2">
        {t("pages:profilePage.billing.changeConfirm.haveCode")}
      </label>
      <div className="flex gap-2">
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={
            t("pages:profilePage.billing.changeConfirm.enterCode") || ""
          }
          className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
        />
        <button
          onClick={onApply}
          disabled={!value.trim() || loading}
          className="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed text-sm"
        >
          {t("common:labels.apply")}
        </button>
      </div>
    </div>
  );
}
